import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { useProfile } from '@lib/profile';
import { CouldNotCreateStepProcessor, NoNextSteps } from '@lib/StepProcessor/errors';

import SignDocumentsStepProcessor from '../lib';

const useSignDocumentsNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { enrollment } = useProfile();

  const [currentActivity, setCurrentActivity] = useState('');

  const getCurrentURL = () => location.pathname;

  const createStepProcessor = () => {
    const { completedActivities } = enrollment;

    if (enrollment.name === 'signing_documents') {
      return new SignDocumentsStepProcessor(completedActivities);
    }

    throw new CouldNotCreateStepProcessor();
  };

  const initializeCurrentActivity = () => {
    let activity = '';

    const url = getCurrentURL();
    const stepProcessor = createStepProcessor();

    activity = stepProcessor.getActivityBy(url);

    if (!activity) {
      activity = stepProcessor.getFirstPendingActivity().name;
    }

    setCurrentActivity(activity);
  };

  const navigateToFirstPendingStep = () => {
    let stepProcessor;

    try {
      stepProcessor = createStepProcessor();
    } catch (error) {
      return navigate('/perfil', { replace: true });
    }

    const firstPendingStep = stepProcessor.getFirstPendingActivity();

    setCurrentActivity(firstPendingStep.name);

    return navigate(firstPendingStep.url, { replace: true });
  };

  const navigateToNextStep = () => {
    let stepProcessor;

    try {
      stepProcessor = createStepProcessor();
    } catch (error) {
      return navigate('/enrollment', { replace: true });
    }

    try {
      const nextStep = stepProcessor.getNextStep(currentActivity);

      setCurrentActivity(nextStep.name, enrollment.name);

      return navigate(nextStep.url, { replace: true });
    } catch (error) {
      if (!(error instanceof NoNextSteps)) throw new Error();

      return navigate('/enrollment', { replace: true });
    }
  };

  const navigateToPreviousStep = () => {
    const stepProcessor = createStepProcessor();
    const previousStep = stepProcessor.getPreviousStep(currentActivity);

    setCurrentActivity(previousStep.name);

    navigate(previousStep.url, { replace: true });
  };

  const isEnabledToAccessToStep = () => {
    let stepProcessor;

    try {
      stepProcessor = createStepProcessor();
    } catch (error) {
      return navigate('/perfil', { replace: true });
    }

    const url = getCurrentURL();

    if (url !== '/sign-documents' && !stepProcessor.isEnabledURL(url)) {
      return false;
    }

    return enrollment.name === 'signing_documents';
  };

  return {
    initializeCurrentActivity,
    isEnabledToAccessToStep,
    navigateToFirstPendingStep,
    navigateToNextStep,
    navigateToPreviousStep
  };
};

export default useSignDocumentsNavigation;
